
import { ENVConfig } from './types';

const config: ENVConfig = {
    baseUrl: '//zcmcommon.58.com',
    zpBaseUrl:'//zpvideo.58.com',
    routerBaseUrl: 'zplive/livesquare/',
};

export default config;